import get from "lodash/get";
import { useContext } from "react";
import type { DatasourceProps } from "types/datasource";
import type { ServerSideStoryblokPages } from "types/storyblok";
import type { PageName } from "utils/getPageUrl/types";
import type { TrustpilotReview, TrustpilotBusinessUnit } from "services/trustpilot/trustpilot";
import type { OptimizelyTransformedExperiment } from "services/optimizely/types";
import { DataContext } from "./DataContext";
import type { CMSLanguagesData, ReferralProgramConfig } from "./hooks.d";

export const useReviews = () => get(useContext(DataContext), "reviews", []) as TrustpilotReview[];

export const useTrustpilotInfo = () => get(useContext(DataContext), "trustpilotInfo", {}) as TrustpilotBusinessUnit;

export const useReferralProgramConfig = () =>
  get(useContext(DataContext), "referralProgramConfig", {}) as ReferralProgramConfig;

export const usePageName = () => get(useContext(DataContext), "pageName", "") as PageName;

export const useCMSLanguageData = () => get(useContext(DataContext), "cmsLanguagesData", []) as CMSLanguagesData[];

export const useServerSideStoryblokPages = () =>
  get(useContext(DataContext), "serverSideStoryblokPages", {}) as ServerSideStoryblokPages;

export const useServerSideStoryblokOtaPages = () =>
  get(useContext(DataContext), "serverSideStoryblokOtaPages", {}) as ServerSideStoryblokPages;

export const useWhiteListDomains = () => get(useContext(DataContext), "whiteListDomains", []) as DatasourceProps[];

export const useNofollowUrls = () => get(useContext(DataContext), "nofollowUrls", []) as string[];

export const useOptimizelyExperiments = () =>
  get(useContext(DataContext), "optimizelyExperiments", []) as Array<OptimizelyTransformedExperiment>;
